<div class="langs-container notranslate">
    <ion-fab>

      <ion-fab-button edge>
        @if (headerLangType() === 'flags') {
          <img draggable="false" [src]="'/assets/isoLangs/' + googleTranslateService.currentLang + '.svg'" alt="{{googleTranslateService.currentLang}}"/>
        }@else {
          <span> {{ googleTranslateService.currentLang }} </span>
        }
      </ion-fab-button>

      <ion-fab-list 
        style="margin-left: 0; margin-right: 0; margin-top: calc(100% + 10px); margin-bottom: calc(100% + 10px); gap: 8px;"
        side="bottom"
      >
        @for(langs of languages(); track $index) {
          @if(langs.code != googleTranslateService.currentLang){
            <ion-fab-button size="large" (click)="changeLanguage(langs.code)">
              <div class="fab-wrapper">
                @if (headerLangType() === 'flags') {
                  <img draggable="false" [src]="langs.img" [alt]="langs.code" />
                }@else {
                  <span> {{ langs.code }} </span>
                }
              </div>
            </ion-fab-button>
          }
        }
        @if(!isTechMode() && !isTechEditMode() && !isRegisterMode() && !isWebApp() && showGoogleLangs()){
          <ion-fab-button size="large" (click)="changeGoogleLanguage()">
            <img draggable="false" class="google-lang-icon" src="/assets/imgs/langs.svg" />
          </ion-fab-button>
        }
      </ion-fab-list>
      
    </ion-fab>
</div>    